import { render, staticRenderFns } from "./JournalsPage.vue?vue&type=template&id=6185a150&scoped=true"
import script from "./JournalsPage.vue?vue&type=script&lang=js"
export * from "./JournalsPage.vue?vue&type=script&lang=js"
import style0 from "./JournalsPage.vue?vue&type=style&index=0&id=6185a150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6185a150",
  null
  
)

export default component.exports